<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Contexto de Medição
    </div>
</div>
  <div>
  @if (checkPermission('criar')) {
    <mat-card class="card-style flex w-full flex-row items-center" style="flex-direction: row !important; align-items: center !important; justify-content: space-around !important;">
      <context-create class="w-11/12" (responseCreate)="uploadList('new')" />
    </mat-card>
  }

<div>
  <div class="mt-4">
<!--    @if (checkPermission('pesquisar-paginado')) {-->
<!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
<!--    }-->
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
  </div>
